<template>
    <div>
        <v-select
            :items="currencies"
            v-model="selected"
            :label="$t('settings.currency.title')"
            :item-text="(item) => `${item.code} ${item.rate} ${item.symbol}`"
            item-value="id"
            @change="itemChange"
            return-object
            >
        </v-select>
    </div>
</template>
<script>
export default {
    props: ['value'],
    data(){
        return {
            selected: this.value,
            currencies: []
        }
    },
    methods: {
        itemChange(event){
            this.$emit('input', this.selected)
        }
    },
    mounted() {
            this.$http.get('/currency/settings')
                    .then((response) => {
                        this.currencies = response.data
                        this.updating = false
                    })
                    .catch(() => {
                        this.updating = false
                    })
    }
}
</script>
<style>
.fixed-width{
    width: max-content;
    max-width: 50% !important;
}
</style>
